<template>
  <div v-if="value">
    <div class="rdrw__scrim" @click="$emit('input', false)"></div>
    <aside class="rdrw" :class="{ 'rdrw--full': !wide }">
      <div class="rdrw__head">
        <button type="button" class="rdrw__close" @click="$emit('input', false)">
          <hero-icon :icon="CloseIcon" :size="15" />
          Cerrar
        </button>
        <span class="rdrw__kicker">{{ detail.kicker }}</span>
      </div>

      <div class="rdrw__body">
        <div class="rdrw__top">
          <div v-if="detail.badges && detail.badges.length" class="rdrw__badges">
            <span
              v-for="(b, i) in detail.badges"
              :key="i"
              class="rdrw__badge"
              :style="{ background: b.bg, color: b.fg }"
            >{{ b.label }}</span>
          </div>
          <h2 class="rdrw__title">{{ detail.title }}</h2>
          <div v-if="detail.sub" class="rdrw__sub">{{ detail.sub }}</div>

          <div v-if="detail.actions && detail.actions.length" class="rdrw__acts">
            <button
              v-for="(a, i) in detail.actions"
              :key="i"
              type="button"
              class="rdrw__act"
              :class="'rdrw__act--' + (a.tone || 'ghost')"
              @click="$emit('action', a.key)"
            >
              <hero-icon :icon="a.icon" :size="16" />
              {{ a.label }}
            </button>
          </div>
        </div>

        <div class="rdrw__section">
          <div class="rdrw__label">Datos</div>
          <div class="rdrw__facts">
            <div v-for="(f, i) in detail.facts" :key="i" class="rdrw__fact">
              <div class="rdrw__factlbl">{{ f.label }}</div>
              <div class="rdrw__factval">{{ f.value }}</div>
            </div>
          </div>

          <template v-if="timelineLoading || (timeline && timeline.length)">
            <div class="rdrw__label rdrw__label--spaced">Recorrido</div>
            <div v-if="timelineLoading" class="rdrw__loading">Cargando recorrido…</div>
            <div v-else class="rdrw__timeline">
              <div v-for="(e, i) in timeline" :key="i" class="rdrw__event">
                <span class="rdrw__dot" :style="{ background: e.dot }"></span>
                <div class="rdrw__eventbody">
                  <div class="rdrw__eventhead">
                    <span class="rdrw__eventkind">{{ e.kind }}</span>
                    <span class="rdrw__eventwhen">{{ e.when }}</span>
                  </div>
                  <div class="rdrw__eventtitle">{{ e.title }}</div>
                  <div v-if="e.detail" class="rdrw__eventdetail">{{ e.detail }}</div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </aside>
  </div>
</template>

<script>
// The row drill-down: everything known about one property / consulta / lead /
// cuenta, plus the person's recorrido when there's a visitor behind it. Slides
// over the report instead of navigating away, so the agent keeps their place in
// the table.
import HeroIcon from "@/components/shared/HeroIcon";
import CloseIcon from "heroicons/24/outline/x-mark.svg";

export default {
  components: { HeroIcon },

  props: {
    value: { type: Boolean, default: false },
    detail: { type: Object, default: () => ({ badges: [], facts: [], actions: [] }) },
    timeline: { type: Array, default: () => [] },
    timelineLoading: { type: Boolean, default: false },
    wide: { type: Boolean, default: true }
  },

  data: () => ({ CloseIcon })
};
</script>

<style scoped>
.rdrw__scrim {
  position: fixed;
  inset: 0;
  background: rgba(26, 24, 20, 0.42);
  z-index: 20;
}
.rdrw {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 760px;
  max-width: 100%;
  background: #fff;
  z-index: 21;
  display: flex;
  flex-direction: column;
  box-shadow: -24px 0 60px -30px rgba(40, 33, 22, 0.5);
  animation: rdrw-slidein 0.18s ease-out;
}
.rdrw--full { width: 100%; }
@keyframes rdrw-slidein {
  from { transform: translateX(24px); opacity: 0; }
  to { transform: none; opacity: 1; }
}

.rdrw__head {
  flex: none;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border-bottom: 1px solid #ece7de;
  background: #faf8f4;
}
.rdrw__close {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: #fff;
  border: 1px solid #e3ddd2;
  border-radius: 8px;
  min-height: 36px;
  padding: 0 14px;
  font-size: 13px;
  font-weight: 600;
  color: #1a1814;
  cursor: pointer;
}
.rdrw__close:hover { background: #f4f0e8; border-color: #dcd4c6; }
.rdrw__kicker { font-size: 11.5px; color: #a39a8c; }

.rdrw__body { flex: 1 1 auto; min-height: 0; overflow-y: auto; }
.rdrw__top { padding: 20px 22px 18px; border-bottom: 1px solid #ece7de; }
.rdrw__badges { display: flex; gap: 7px; flex-wrap: wrap; margin-bottom: 9px; }
.rdrw__badge {
  font-size: 10.5px;
  font-weight: 700;
  padding: 2px 9px;
  border-radius: 999px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.rdrw__title { font-size: 21px; font-weight: 700; color: #1a1814; margin: 0; line-height: 1.2; }
.rdrw__sub { font-size: 13.5px; color: #756f64; margin-top: 5px; }

.rdrw__acts { display: flex; gap: 8px; flex-wrap: wrap; margin-top: 16px; }
.rdrw__act {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 38px;
  padding: 0 16px;
  border-radius: 8px;
  border: 1px solid #e3ddd2;
  background: #fff;
  color: #1a1814;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}
.rdrw__act:hover { opacity: 0.88; }
.rdrw__act--ink { background: #1a1814; border-color: #1a1814; color: #fff; }
.rdrw__act--accent { background: #b52118; border-color: #b52118; color: #fff; }

.rdrw__section { padding: 18px 22px 28px; }
.rdrw__label {
  font-size: 10px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #a39a8c;
  font-weight: 600;
  margin-bottom: 12px;
}
.rdrw__label--spaced { margin: 22px 0 10px; }

.rdrw__facts {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1px;
  background: #f1ece3;
  border: 1px solid #f1ece3;
  border-radius: 12px;
  overflow: hidden;
}
.rdrw__fact { background: #fff; padding: 12px 14px; }
.rdrw__factlbl { font-size: 11px; color: #a39a8c; font-weight: 600; }
.rdrw__factval {
  font-size: 14px;
  font-weight: 600;
  color: #1a1814;
  margin-top: 3px;
  font-variant-numeric: tabular-nums;
  word-break: break-word;
}

.rdrw__loading { font-size: 13px; color: #a39a8c; padding: 8px 0; }
.rdrw__timeline { display: flex; flex-direction: column; }
.rdrw__event { display: flex; align-items: flex-start; gap: 12px; padding: 10px 0; }
.rdrw__dot { flex: none; width: 10px; height: 10px; border-radius: 50%; margin-top: 5px; }
.rdrw__eventbody { flex: 1 1 auto; min-width: 0; border-bottom: 1px solid #f1ece3; padding-bottom: 10px; }
.rdrw__eventhead { display: flex; align-items: center; justify-content: space-between; gap: 8px; }
.rdrw__eventkind {
  font-size: 10px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  font-weight: 700;
  color: #a39a8c;
}
.rdrw__eventwhen { font-size: 11.5px; color: #a39a8c; }
.rdrw__eventtitle { font-size: 13.5px; font-weight: 600; color: #1a1814; margin-top: 3px; }
.rdrw__eventdetail { font-size: 12.5px; color: #756f64; margin-top: 2px; }

@media (max-width: 1199px) {
  .rdrw__facts { grid-template-columns: 1fr; }
  .rdrw__act { min-height: 44px; flex: 1 1 auto; }
}
</style>
